<template>
  <div class="pb-5">
    <ModalDiversityInputs />
    <b-card no-body class="border-0 bg-transparent mt-4">
      <div class="card-header border-0 shadow-sm card-nav-tabs">
        <ul class="nav card-header-tabs">
          <li class="nav-item">
            <a
              href="#"
              class="nav-link"
              :class="{ active: tabIndex == 0 }"
              @click="changeTab(0, $event)"
              >{{
                windowWidth <= 420 ? "Info. Básicas" : "Informações Básicas"
              }}</a
            >
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link"
              :class="{ active: tabIndex == 1 }"
              @click="changeTab(1, $event)"
              >{{
                windowWidth <= 420
                  ? "Info. Complementares"
                  : "Informações Complementares"
              }}</a
            >
          </li>
        </ul>
      </div>

      <b-tabs
        card
        no-nav-style
        nav-wrapper-class="shadow-sm border-0 card-nav-tabs d-none"
        v-model="tabIndex"
      >
        <b-tab class="row">
          <div class="bg-white border-0 shadow-sm p-4 p-md-5 position-relative">
            <LoaderContent
              v-if="!graphql_loaded"
              :welcomeMessage="false"
              :alignSpinnerTop="true"
            />
            <div v-else>
              <FormPersonalData ref="formPersonalData" />
            </div>
          </div>
        </b-tab>

        <b-tab class="row">
          <div class="bg-white shadow-sm p-4 p-md-5">
            <BoxEducation format="modal-form" v-if="showField('education', 'education')" />

            <hr class="pb-3" v-if="showField('education', 'education')" />

            <BoxProfessionalExp format="modal-form" v-if="showField('professional_experience', 'professional_experience')" />

            <hr class="pb-3" v-if="showField('professional_experience', 'professional_experience')" />

            <BoxLanguage v-if="showField('languages', 'languages')" />

            <hr class="pb-3" v-if="showField('languages', 'languages')" />

            <BoxIndication v-if="showIndicationForm"  />
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <div class="row" v-if="graphql_loaded">
      <div class="col-12 text-right">
        <p class="small text-right font-italic">
          Campos com * são obrigatórios.
        </p>
      </div>

      <div class="col-12 text-center">
        <button
          @click="trySubmit()"
          class="btn btn-lg btn-color-1"
          :disabled="isSaving"
        >
          <span v-if="!isSaving">
            {{
              hasTests || tabIndex == 0
                ? "Próxima Etapa"
                : "Finalizar Inscrição"
            }}</span
          >
          <EllipsisLoader v-else />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDiversityInputs from "@/components/ModalDiversityInputs.vue";
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";
import EllipsisLoader from "ninenine-white-label/src/components/Loader/EllipsisLoader.vue";
import FormPersonalData from "ninenine-white-label/src/components/PersonalData/FormPersonalData.vue";
import BoxEducation from "ninenine-white-label/src/components/Education/BoxEducation.vue";
import BoxProfessionalExp from "ninenine-white-label/src/components/ProfessionalExp/BoxProfessionalExp.vue";
import BoxLanguage from "ninenine-white-label/src/components/Language/BoxLanguage.vue";
import BoxIndication from "ninenine-white-label/src/components/Indication/BoxIndication.vue";
import FormQuestions from "ninenine-white-label/src/components/Questions/FormQuestions.vue";

export default {
  name: "SubscriptionForm",

  data() {
    return {
      tabIndex: 0,
      windowWidth: window.innerWidth,
      graphql_loaded: false,
      isSaving: false,
      eliminatoryQuestionsResponse: "",
    };
  },

  head() {
    return this.$head({
      title: "",
      canonical: ``,
      meta_description: "",
    });
  },

  computed: {
    hasTests() {
      return (
        this.$store.state.opportunities.currentOpportunity &&
        this.$store.state.opportunities.currentOpportunity.opportunity_tests &&
        this.$store.state.opportunities.currentOpportunity.opportunity_tests
          .length > 0
      );
    },

    showIndicationForm() {
      return (
        this.$store.state.opportunities.currentOpportunity &&
        this.$store.state.opportunities.currentOpportunity.indication_domains &&
        this.$store.state.opportunities.currentOpportunity.indication_domains.length > 0
      )
    }
  },

  components: {
    ModalDiversityInputs,
    LoaderContent,
    EllipsisLoader,
    FormPersonalData,
    BoxEducation,
    BoxProfessionalExp,
    BoxLanguage,
    BoxIndication,
    FormQuestions,
  },

  mounted() {
    this.preSubscription()

    setTimeout(() => this.removeAutoFillSelectize(), 500);
    let requestDomainReturn = "";

    if (this.$store.state.domains.countries.length == 0) {
      requestDomainReturn += `countries { id, name },`;
    }

    requestDomainReturn += `genders { id, description },`;
    requestDomainReturn += `raceAndEthnicities { id, description },`;
    requestDomainReturn += `pronouns { id, description },`;
    requestDomainReturn += `personalIncomes { id, description },`;
    requestDomainReturn += `familyIncomes { id, description },`;
    requestDomainReturn += `sexualOrientations {id, description},`;
    requestDomainReturn += `disabilities { id, name },`;

    if (this.$store.state.domains.maritalStatus.length == 0) {
      requestDomainReturn += `maritalStatus {id, description},`;
    }
    if (this.$store.state.domains.states.length == 0) {
      requestDomainReturn += `states { id, name, abbr },`;
    }
    if (this.$store.state.domains.education_levels.length == 0) {
      requestDomainReturn += `educationLevels {id, description},`;
    }
    if (this.$store.state.domains.education_periods.length == 0) {
      requestDomainReturn += `educationPeriods {id, description},`;
    }
    if (this.$store.state.domains.education_status.length == 0) {
      requestDomainReturn += `educationStatus {id, description},`;
    }

    if (this.$store.state.domains.companies.length == 0) {
      requestDomainReturn += `companies {id, name},`;
    }
    if (this.$store.state.domains.professional_experience_areas.length == 0) {
      requestDomainReturn += `professionalExperienceAreas {id, name},`;
    }
    if (this.$store.state.domains.professional_experience_levels.length == 0) {
      requestDomainReturn += `professionalExperienceLevels {id, name}`;
    }

    if (this.$store.state.domains.cause_experience_areas.length == 0) {
      requestDomainReturn += `causeExperienceAreas {id, description},`;
    }

    if (this.$store.state.domains.language_proficiencies.length == 0) {
      requestDomainReturn += `languageProficiencies {id, description},`;
    }

    if (requestDomainReturn.length > 0) {
      requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
    }

    this.$store
      .dispatch(
        "graphql_queries/query",
        `
        ${requestDomainReturn}
        user( id: "${this.$store.state.user.profile.id}" ){
          avatar,
          medicalReports {
            id,
            name,
            file
          },
          profile{
            firstname,
            lastname,
            socialName,
            email,
            nationality,
            cpf,
            passport,
            gender,
            sexualOrientation,
            raceAndEthnicity,
            pronoun,
            personalIncome,
            familyIncome,
            sexualOrientation,
            descriptionHelpSelectionProcess,
            needHelpSelectionProcess,
            maritalStatus,
            phone,
            birthday,

            location {
              zipcode,
              street,
              number,
              complement,
              neighborhood,
              stateId,
              city
            },

            hasDisability,

            disabilities {
              disabilityId,
              name
            },

            educations {
              id,
              institutionName,
              level,
              courseName,
              startDate,
              endDate,
              stateId
            },

            professionalExperiences {
              id,
              role,
              responsabilities,
              company,
              startYear,
              endYear
            },

            languageProficiencies {
              id,
              language,
              proficiency
            },

            additionalQuestions {
              id,
              question,
              answer,
              slug
            }

          }
        },
      `
      )
      .then((results) => {
        this.graphql_loaded = true;
        setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
      });

    this.setIndeedTag();
  },

  methods: {
     async preSubscription(){
      if(this.$route.params.id.match(/\d+/)[0]){
        const preSubscriptionRequest = await this.$store.dispatch('opportunities/createAndIndexSubscriptionLead', {
          opportunity_id: this.$route.params.id.match(/\d+/)[0],
        });
      }
    },

    setIndeedTag(){
      let divScripts = document.getElementById('someExtraContent');

      let newScript = document.createElement('script');
      newScript.src = 'https://convcdn.indeed.tech/ld-min.js';
      divScripts.appendChild(newScript);

      newScript = document.createElement('script');
      newScript.src = '/indeed_landing_page.js';
      divScripts.appendChild(newScript);
    },

    scroll() {
      window.scroll(0, 1);
    },

    async changeTab(tab, event) {
      if (event) event.preventDefault();

      if (this.tabIndex == 0) {
        if (
          this.validateBasicInfo() == true &&
          (await this.validateEliminatoryQuestions()) == true
        ) {
          this.tabIndex = tab;
          this.scroll();
        }
      } else {
        this.tabIndex = tab;
        this.scroll();
      }
    },

    validateBasicInfo() {
      let canSubmit = false;

      this.$EventBus.$emit("storePersonalDataForm");

      if (this.$store.state.personalDataForm.error) {
        canSubmit = false;
      } else {
        this.$EventBus.$emit("storeQuestions");

        if (this.$store.state.opportunityQuestionsForm.error) {
          canSubmit = false;
        } else {
          canSubmit = true;
        }
      }

      return canSubmit;
    },

    validateExtraInfo() {
      let canSubmit = false;

      if (
        this.$store.state.flag_no_professional_experience == false &&
        this.$store.state.user.profile.professionalExperiences.length == 0 &&
        this.$store.state.flag_no_professional_experience == false &&
        this.showField('professional_experience', 'professional_experience')
      ) {
        canSubmit = false;
        this.$swal("Uoops", "Informe sua experiência profissional", "error");
      } else {
        this.$EventBus.$emit("storeIndication");

        if (this.$store.state.indicationForm.error) {
          canSubmit = false;
        } else {
          canSubmit = true;
        }
      }

      return canSubmit;
    },

    async validateEliminatoryQuestions() {
      const opportunity_questions = JSON.parse(
        localStorage.getItem("opportunity_questions")
      );
      const opportunityId = this.$route.params.id.match(/\d+/)[0];

      if (!opportunity_questions) {
        return false;
      }

      if (opportunity_questions.data.questions.length == 0) {
        return true;
      }

      this.isSaving = true;
      const validateEliminatoryQuestions = await this.$store.dispatch(
        "opportunities/validateCandidateEliminatoryQuestions",
        {
          opportunity_id: opportunityId,
          questions: opportunity_questions.data.questions,
        }
      );
      this.isSaving = false;

      if (validateEliminatoryQuestions.subscribe == "true") {
        return true;
      } else {
        // Já que ele será redirecionado para uma tela de erro, vamos salvar os dados pessoais dele para que ele não perca o que já informou
        await this.$store.dispatch(
          "user/personalDataUpdate",
          this.$store.state.personalDataForm.data
        );
        this.$router.push({
          name: "inscricao-recusada",
          params: { template: validateEliminatoryQuestions.template },
        });
      }
    },

    async trySubmit() {
      let canSubmit = false;

      if (this.tabIndex == 0) {
        if (
          this.validateBasicInfo() == true &&
          (await this.validateEliminatoryQuestions()) == true
        ) {
          this.changeTab(1);
        }
      } else if (this.tabIndex == 1) {
        canSubmit = this.validateExtraInfo();
      }

      if (canSubmit) {
        this.isSaving = true;
        const personalData = this.$store.state.personalDataForm.data;
        personalData.source = " ";
        const savePersonal = personalData
          ? await this.$store.dispatch("user/personalDataUpdate", personalData)
          : null;

        if (savePersonal && savePersonal.error) {
          this.isSaving = false;
          this.$swal(
            "Uoops",
            "Ocorreu um erro ao salvar suas informações",
            "error"
          );
          return;
        } else {
          if (!this.hasTests) {
            this.isSaving = true;
            await this.subscribeUser();
            this.isSaving = false;
          } else {
            this.isSaving = false;
            this.$router.push(
              `/vagas/${this.$route.params.id}/inscricao/testes`
            );
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .form-group {
  margin-bottom: 1.3rem;
  & > label,
  & > div > label {
    color: #6c757d;
  }
}

/deep/.input-avatar{
  .account-circle-icon{
    color: red;
  }
}

/deep/ .input-avatar-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: -20px;

  @include media-breakpoint-down(sm) {
    margin-top: 0;
  }

  img {
    width: 80px;
    height: 80px;
  }
}


</style>